import { reconcile, type SetStoreFunction } from "solid-js/store"
import { createSessionSnapshotLoader } from "./status-snapshot"
import type { GlobalStore } from "./types"

/**
 * Keeps `session_waiting` in step with the machine: snapshots on connect and
 * after event gaps, `session.waiting` events in between.
 */
export function createSessionWaitingController(input: {
  setStore: SetStoreFunction<GlobalStore>
  load: () => Promise<Record<string, number>>
  connected: () => boolean
}) {
  const snapshots = createSessionSnapshotLoader({
    load: input.load,
    apply(waiting) {
      // An event can report zero for a chat the snapshot still listed.
      const counts = Object.fromEntries(Object.entries(waiting).filter(([, launches]) => launches > 0))
      input.setStore("session_waiting", reconcile(counts))
    },
  })
  return {
    /** A machine snapshot has replaced the counts this page started with, which may be a cache's. */
    get confirmed() {
      return snapshots.confirmed
    },
    refresh: () => input.connected() ? snapshots.refresh() : Promise.resolve(false),
    accept(sessionID: string, launches: number) {
      snapshots.changed(sessionID, launches)
      input.setStore("session_waiting", sessionID, launches > 0 ? launches : undefined)
    },
  }
}
